import { toggleNoiseSuppression } from '../../../../../react/features/noise-suppression/actions';
import { isNoiseSuppressionEnabled } from '../../../../../react/features/noise-suppression/functions';
export function submitNoiseTab(props) {
    return async (dispatch, getState) => {
        const state = getState();
        const { noiseSuppressionEnabled } = props;
        if (noiseSuppressionEnabled !== isNoiseSuppressionEnabled(state)) {
            dispatch(toggleNoiseSuppression());
        }
    };
}
